import { Reveal } from "./Reveal";
import { PROCESS } from "../lib/data";

export const Process = () => (
  <section id="process" data-testid="process-section" className="relative py-20 md:py-32 border-t border-white/5 bg-[#080808] scroll-mt-24">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="max-w-3xl mb-12 md:mb-16">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-5 md:mb-6">Process</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-black uppercase tracking-tight text-white text-3xl sm:text-4xl md:text-6xl leading-[0.95]">
            From brief to <span className="text-[#D4AF37]">final serve.</span>
          </h2>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
        {PROCESS.map((p, i) => {
          const Icon = p.icon;
          return (
            <Reveal key={p.title} delay={0.08 * i}>
              <div
                data-testid={`process-step-${i}`}
                className="h-full bg-[#0a0a0a] border border-white/5 hover:border-[#D4AF37]/40 transition-colors duration-500 p-6 md:p-7 flex flex-col min-h-[180px]"
              >
                <div className="flex items-center justify-between">
                  <Icon className="w-7 h-7 text-[#D4AF37]" strokeWidth={1.4} />
                  <span className="font-display font-black text-white/10 text-3xl md:text-4xl leading-none">{p.step}</span>
                </div>
                <h3 className="mt-6 font-display font-bold uppercase tracking-wide text-white text-lg md:text-xl">{p.title}</h3>
                <p className="mt-2 text-sm text-white/55 font-light leading-relaxed">{p.copy}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
